import { Check } from 'lucide-react';
import type { InvoiceStatus } from '@/types';
import { cn } from './cn';

const STYLES: Record<string, string> = {
  tentative: 'border border-dashed border-zinc-400 text-[var(--text-muted)]',
  draft: 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300',
  sent: 'bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-300',
  overdue: 'bg-orange-50 text-orange-700 dark:bg-orange-950 dark:text-orange-300',
  paid: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300',
  archived: 'bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400',
  discarded: 'bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400'
};

export function isOverdue(inv: { status: InvoiceStatus; dueDate: string | null }) {
  return inv.status === 'sent' && !!inv.dueDate && inv.dueDate < new Date().toISOString().slice(0, 10);
}

/** Status badge. `label` overrides the text ("Sent Oct 1 · viewed Oct 2"). */
export function StatusPill({ status, overdue, label, large }: { status: InvoiceStatus; overdue?: boolean; label?: string; large?: boolean }) {
  const key = overdue ? 'overdue' : status;
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-[3px] rounded-full font-medium capitalize',
        large ? 'h-6 px-2.5 text-caption' : 'h-[22px] px-2 text-[12px]',
        STYLES[key]
      )}
    >
      {key === 'paid' && <Check className="size-3" strokeWidth={3} />}
      {label ?? key}
    </span>
  );
}
